import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ObjectPageComponent} from "../../../../../core/shared/object/mvs-object-page-component/object-page.component";

// NOT_IN_USE
@Component({
    selector: 'mvs-pc-call-page',
    templateUrl: './pc-call.page.html',
    standalone: false
})
export class PcCallPage
    extends ObjectPageComponent
    implements OnInit, OnDestroy, OnChanges {

  defaultLabel: string = "Anruf";


  protected getObjectType(): string {
    return "pc.Call";
  }

}
